import { render, staticRenderFns } from "./partInfo.vue?vue&type=template&id=07fb7a52&scoped=true&"
import script from "./partInfo.vue?vue&type=script&lang=js&"
export * from "./partInfo.vue?vue&type=script&lang=js&"
import style0 from "./partInfo.vue?vue&type=style&index=0&id=07fb7a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fb7a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fb7a52')) {
      api.createRecord('07fb7a52', component.options)
    } else {
      api.reload('07fb7a52', component.options)
    }
    module.hot.accept("./partInfo.vue?vue&type=template&id=07fb7a52&scoped=true&", function () {
      api.rerender('07fb7a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inOutBound/statis/partInfo.vue"
export default component.exports